<template>
  <div class="verifyCertificate font-17">
    <topNav />
    <div class="container my-5">
      <h3 class="text-center font-weight-bold mb-1">
        ใบประกาศนียบัตร (E-Certificate)
      </h3>
      <p class="text-center text-muted mb-4">
        ตรวจสอบใบประกาศนียบัตรอิเล็กทรอนิกส์
      </p>

      <template v-if="token">
        <div class="cert-frame-wrapper">
          <iframe
            :src="viewUrl"
            class="cert-frame"
            title="E-Certificate"
          ></iframe>
        </div>
        <div class="text-center mt-4">
          <button class="btn btn-primary" @click="download">
            ดาวน์โหลดใบประกาศนียบัตร
          </button>
        </div>
      </template>

      <template v-else>
        <p class="text-center text-danger my-5">
          ไม่พบรหัสสำหรับตรวจสอบใบประกาศนียบัตร (token ไม่ถูกต้อง)
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import { domain } from "../util/Constants";
import topNav from "@/components/topNav.vue";

export default {
  name: "VerifyCertificate",
  components: {
    topNav,
  },
  computed: {
    token() {
      return this.$route.query.token || "";
    },
    pdfUrl() {
      // PDF stream — used by the Download button (same endpoint as before).
      if (!this.token) return "";
      const t = encodeURIComponent(this.token);
      const origin = encodeURIComponent(window.location.origin);
      return `${domain}certificate-template?token=${t}&fe_url=${origin}`;
    },
    viewUrl() {
      // HTML render of the cert (no PDF viewer chrome) for inline display.
      if (!this.token) return "";
      const t = encodeURIComponent(this.token);
      const origin = encodeURIComponent(window.location.origin);
      return `${domain}certificate-view?token=${t}&fe_url=${origin}`;
    },
  },
  methods: {
    download() {
      if (this.pdfUrl) window.open(this.pdfUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.cert-frame-wrapper {
  width: 100%;
  max-width: 1150px;
  margin: 32px auto;
  padding: 14px;
  background: #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
}
.cert-frame {
  display: block;
  width: 100%;
  aspect-ratio: 700 / 500;
  border: 0;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
}
</style>
